import * as THREE from 'three';
import { SkeletonUtils } from 'three-stdlib';

export const cloneModel = (originalModel: THREE.Object3D) => {
    const clonedModel = SkeletonUtils.clone(originalModel);
    /*clonedModel.removeFromParent();
    clonedModel.position.set(0, 0, 0);
    clonedModel.rotation.set(0, 0, 0);

    clonedModel.scale.copy(originalModel.getWorldScale(new THREE.Vector3()));
    */

    clonedModel.traverse(object => {
        if (object.geometry) object.geometry = object.geometry.clone();
        if (object.material) object.material = object.material.clone();
    });

    return clonedModel;
};